import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@aimsos/auth';

import { WidgetBuilderEditPage, WidgetBuilderNewPage, WidgetLibraryPage } from './pages';

/**
 * Domain root for the Widget Library and the Widget Playground (CT-5183).
 *
 * Paths are RELATIVE to the parent route that mounts this component:
 *   - Shell:      <Route path="widgets/*">  (apps/core-shell/src/App.jsx)
 *   - Standalone: <Route path="dashboards/*"> then `widgets/*` inside DashboardsApp
 *
 * Mirrors `domains/dashboards/Dashboards.jsx`. No provider wrapper yet — the
 * builder form state is a plain hook until CT-5190 proves a context is needed.
 */
function Widgets() {
  return (
    <Routes>
      <Route
        index
        element={
          <ProtectedRoute>
            <WidgetLibraryPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="new"
        element={
          <ProtectedRoute>
            <WidgetBuilderNewPage />
          </ProtectedRoute>
        }
      />
      <Route
        path=":widgetId/edit"
        element={
          <ProtectedRoute>
            <WidgetBuilderEditPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="" replace />} />
    </Routes>
  );
}

export default Widgets;
